import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getQuoteMostRecent } from "../api/getQuotes";

class MostRecentQuoteContainer extends React.Component {
  componentDidMount() {
    const {} = this.props;
    this.props.request();
  }

  //   componentDidUpdate(prevProps) {
  //     if (this.props.days !== prevProps.days) {
  //       this.props.request(this.props.days);
  //     }
  //   }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const quote = (data && data.data && data.data.quote) || [];
    return render({ quote, loading, failure });
  };
}

MostRecentQuoteContainer.propTypes = {};

MostRecentQuoteContainer.defaultProps = {};

export default CreateContainer(getQuoteMostRecent, MostRecentQuoteContainer);
